require.context("../images", true);
import TranslationActionsController from "../src/decidim/idealtranslations/controllers/translation_actions/controller";
window.Stimulus.register("translation-actions", TranslationActionsController);
